export default [
    {
        path: '/logistic/warehouse/emons-stock-dfference',
        name: 'warehouse_emons_stock_difference',
        component: () => import('@src/warehouse/emons-stock-difference'),
        meta: {
            title: 'Emons Bestandsabgleich',
            role: 'ROLE_EMONS_STOCK_DIFFERENCE',
        },
    },
    {
        path: '/stock-transaction/exit-nuk',
        name: 'stock_exit_nuk',
        meta: {
            title: 'NUK auslagern',
            role: 'ROLE_STOCK_EXIT',
        },
        component: () => import('@src/warehouse/stock-exit-nuk'),
    },
    {
        path: '/stock-transaction/exit-serial',
        name: 'stock_exit_serial',
        meta: {
            title: 'Auslagern',
            role: 'ROLE_STOCK_EXIT',
        },
        component: () => import('@src/warehouse/stock-exit-serial'),
    },
    {
        path: '/product/serial-to-nuk',
        name: 'serial_to_nuk',
        component: () => import('@src/warehouse/serial-to-nuk.vue'),
        meta: {
            title: 'in NUK umwandeln',
            role: 'ROLE_SERIAL_TO_NUK',
        },
    },
    {
        path: '/product/print-product-label',
        name: 'print_product_label',
        component: () => import('@src/warehouse/print-product-label.vue'),
        meta: {
            title: 'Produktlabel Drucken',
            role: 'ROLE_PRINT_PRODUCT_LABEL',
        },
    },
    {
        path: '/warehouse/detail/bin-report/:id?',
        name: 'detail_bin_report',
        component: () => import('@src/warehouse-detail/show-bin.vue'),
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        meta: {
            title: 'Lagerfachdetails',
            role: 'ROLE_SHOW_BIN_REPORT',
            favoriteRouteName: 'detail_bin_report',
        },
    },
    {
        path: '/warehouse/print-bin-labels/:rack?',
        name: 'bin_labels',
        component: () => import('@src/warehouse/print-bin-labels.vue'),
        meta: {
            title: 'Lagerfachetiketten',
            role: 'ROLE_PRINT_BIN_LABEL',
        },
    },
];
